var map = {
	"./about.js": "./js/barba/views/about.js",
	"./artisan.js": "./js/barba/views/artisan.js",
	"./coffee.js": "./js/barba/views/coffee.js",
	"./contact.js": "./js/barba/views/contact.js",
	"./default.js": "./js/barba/views/default.js",
	"./home.js": "./js/barba/views/home.js",
	"./locations.js": "./js/barba/views/locations.js",
	"./product_category.js": "./js/barba/views/product_category.js",
	"./product_index.js": "./js/barba/views/product_index.js",
	"./wholesale.js": "./js/barba/views/wholesale.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/barba/views sync \\.js$";